import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { PageDetail } from '@trinity/management-app-client';
import { useChatApiClient } from '../containers/Chat/useApiClient';

export function usePage(id: number | null): UseQueryResult<PageDetail> {
  const apiClient = useChatApiClient();

  return useQuery({
    queryKey: ['page', id],
    queryFn: async (): Promise<PageDetail> => {
      if (id === null) {
        throw new Error('Page id is required');
      }

      return apiClient.pages.getPage(id);
    },
    enabled: id !== null,
  });
}
